const openpathConfig = require('openpathConfig');

export const locizeOptions = {
  projectId: openpathConfig.LOCIZE_PROJECTID,
  apiKey: openpathConfig.LOCIZE_APIKEY,
  version: openpathConfig.LOCIZE_VERSION,
  referenceLng: openpathConfig.LOCIZE_REFLNG,
};
